<template>
  <div class="ss__dialog2__wrapper" :class="{'ss__dialog2__wrapper--visible': visible}">
    <transition name="mask">
      <div v-show="visible" class="ss__dialog2__mask" @click="onModalClick"></div>
    </transition>
    <template v-if="$slots.dialog">
      <transition name="body">
        <div v-show="visible" class="ss__dialog2--blank" @click.self="close">
          <slot name="dialog"/>
          <button v-if="btnCloseVisible" class="btn__close" @click="cancel"><i class="ssCommunityIcon__cancel"/></button>
        </div>
      </transition>
    </template>
    <template v-else>
      <transition name="body">
        <div v-show="visible" class="ss__dialog2">
          <div class="dialog__header">
            <button v-if="btnCloseVisible" class="btn__close" @click="cancel"><i class="ssCommunityIcon__cancel"/></button>
            <span class="dialog__title text__bold">{{ title }}</span>
            <button v-if="btnSubmitVisible" class="btn__submit" @click="submit"><span class="text__bold">确定</span></button>
          </div>
          <div class="dialog__body__wrapper">
            <slot></slot>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SsDialog2',

  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    btnSubmitVisible: {
      type: Boolean,
      default: true
    },
    btnCloseVisible: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      preventScroll: false
    }
  },

  watch: {
    visible () {
      const htmlEl = document.documentElement
      if (this.visible) {
        const overflow = getComputedStyle(htmlEl).getPropertyValue('overflow')
        const overflowY = getComputedStyle(htmlEl).getPropertyValue('overflow-y')
        if (overflow === 'hidden' || overflowY === 'hidden') {
          this.preventScroll = false
        } else {
          this.preventScroll = true
          htmlEl.style.overflowY = 'hidden'
        }
      } else if (this.preventScroll) {
        setTimeout(() => {
          htmlEl.style.overflowY = ''
        }, 360)
      }
    }
  },

  methods: {
    close () {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    onModalClick () {
      if (this.closeOnClickModal) {
        this.cancel()
      }
    },
    cancel () {
      this.$emit('cancel')
      this.close()
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'

.ss__dialog2__wrapper {
  width: 100%
  height: calc(var(--vh, 1vh) * 100)
  position: fixed
  top: 0
  left: 0
  display: flex
  visibility: hidden
  transition: visibility 0s $a-dur-default
  &.ss__dialog2__wrapper--visible {
    visibility: visible
    transition: visibility 0s 0s
  }

  .ss__dialog2__mask {
    position: fixed
    z-index: 199
    width: 100%
    height: 100%
    top: 0
    left: 0
    background: rgba(124, 126, 129, 0.8)
  }

  .ss__dialog2 {
    z-index: 200
    margin: auto
    margin-bottom: 0px
    width: 100%
    height: auto
    max-height: calc(var(--vh, 1vh) * 75)
    background: var(--color-bg-ssDialog2, var(--B0-t))
    border-radius: var(--radius-ssDialog2, (20px 20px 0 0))
    display: flex
    flex-direction: column
    box-shadow: var(--shadow-level-2)
    .dialog__header {
      display: flex
      justify-content: space-between
      align-items: center
      padding: var(--inset-ssDialog2Header, (24px 20px 8px))
      text-align: center
      font-size: var(--text-ssDialog2header, 17px)
      line-height: var(--leading-ssDialog2header, 24px)

      position relative
      .dialog__title {
        margin: auto
        font-weight: 500
        max-width: calc(100% - 120px)
      }
      .btn__close {
        position: absolute
        top: 0
        left: 0
        margin: var(--inset-ssDialog2BtnClose, 20px 0px 14px 20px)
        display: flex
        align-items: center
        width: 28px
        height: 28px
        border-radius: 50%
        background: var(--color-bg-ssDialog2BtnClose, var(--B2-t))
        color: var(--color-ssDialog2BtnClose, var(--B6-t))
        font-size: 28px
        @media (max-width: ($screen-lg - 1px)) {
          .ssCommunityIcon__cancel::before {
            content: '\e906';
          }
        }
      }
      .btn__submit {
        font-size: 17px
        line-height: 28px
        &:disabled {
          color: var(--color-ssDialog2BtnSubmit, var(--B6-t))
        }
      }
    }
    .dialog__body__wrapper {
      flex: 1
      padding: var(--padding-ssDialog2Body, (12px 16px 50px))
      overflow: auto
    }
  }

  .ss__dialog2--blank {
    width: 100%
    max-height: calc(var(--vh, 1vh) * 100)
    position: fixed
    z-index: 200
    width: 100%
    height: 100%
    top: 0
    left: 0
    .btn__close {
      position: absolute
      top: 24px
      right: 24px
      font-size: 24px
      color: var(--color-ssDialog2BtnClose, var(--B8-t))
    }
  }

  .mask-enter-active,
  .mask-leave-active {
    opacity: 1
    transition: all $a-dur-default $a-func-default
  }

  .mask-enter,
  .mask-leave-to {
    opacity: 0
  }

  .body-enter-active,
  .body-leave-active {
    opacity: 1
    transform: translateY(0)
    transition: all $a-dur-default $a-func-default
  }

  .body-enter,
  .body-leave-to {
    opacity: 0
    transform: translateY(calc(var(--vh, 1vh) * 50))
  }
}

@media (min-width $screen-lg) {
  .ss__dialog2__wrapper {
    --padding-ssDialog2Body 24px
    .ss__dialog2 {
      max-width: 626px
      margin-bottom: auto
      border-radius: var(--radius-ssDialog2-lg, 20px)
      overflow: hidden
      .dialog__header {
        font-size: var(--text-ssDialog2Header-lg, 20px)
        line-height: var(--leading-ssDialog2Header-lg, 28px)
        .btn__close {
          left: auto
          right: 0
          margin: var(--inset-ssDialog2BtnClose, 24px 24px 0px 0px)
          display: inline-flex
          background: transparent
          color: var(--B8-t)
          width: 24px
          height: 24px
          font-size: 24px
        }
      }
      .dialog__body__wrapper {
        scrollbar-width: thin
        scrollbar-color: var(--B3-t) var(--B0-t)
        &::-webkit-scrollbar {
          width: 0px
        }
        &::-webkit-scrollbar-thumb {
          background: var(--B3-t)
          width: 4px
          border-radius: 8px
        }
      }
    }
  }
}

</style>
